import * as React from "react"
import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils"

// Styled native <select>. `@radix-ui/react-select` is not a dependency here
// (package-lock.json is byte-guarded), so this wraps a plain <select> instead
// of a Radix primitive. Height is `h-11 md:h-11` (not input.tsx's
// `h-11 md:h-9`) so this control never drops under the 44x44 accessibility
// floor at md+ breakpoints.
const NativeSelect = React.forwardRef<HTMLSelectElement, React.ComponentProps<"select">>(
  ({ className, children, ...props }, ref) => {
    return (
      <div className="relative w-full">
        <select
          className={cn(
            "flex h-11 w-full appearance-none rounded-md border border-input bg-background px-3 py-1 pr-9 text-base shadow-elevation-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:h-11 md:text-sm",
            className
          )}
          ref={ref}
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
          aria-hidden="true"
        />
      </div>
    )
  }
)
NativeSelect.displayName = "NativeSelect"

export { NativeSelect }
